/**
 * This is a banner to congratulate user on finishing the exercise.
 */

import { ReactElement } from "react";

interface BannerProps {
  exerciseTitle: string;
  onNextClick: () => void;
}
export function Banner({
  exerciseTitle,
  onNextClick,
}: BannerProps): ReactElement {
  return (
    <div>
      <h1>Congratulations!</h1>
      <p>You have finished the exercise!</p>
      <p>{exerciseTitle}</p>
      <button onClick={onNextClick}>Next</button>
    </div>
  );
}
